import achieveVictoryStrategyFactory from './strategy/achieveVictoryStrategyFactory.js';
import doNothingStrategyFactory from './strategy/doNothingStrategyFactory.js';
import incurDamageStrategyFactory from './strategy/incurDamageStrategyFactory.js';
import moveTowardsEnemyStrategyFactory from './strategy/moveTowardsEnemyStrategyFactory.js';
import supportFriendlyUnitStrategyFactory from './strategy/supportFriendlyUnitStrategyFactory/index.js';
import preventDefeatStrategyFactory from './strategy/preventDefeatStrategyFactory/index.js';
import simpleAgent from './recipes/simpleAgent.js';
function createStrategies(agentSide, hexProperties, mapHexes, scenario, rules, strategyIngredients = []) {
    const createStrategy = getFactories(agentSide, hexProperties, mapHexes, scenario, rules);
    let strategyCache = {};
    const strategies = [];
    const ingredients = strategyIngredients.length ? strategyIngredients : simpleAgent;
    for (let ingredient of ingredients) {
        if (!strategyCache[ingredient.name]) {
            strategyCache[ingredient.name] = createStrategy[ingredient.name]();
        }
        strategies.push({
            strategy: strategyCache[ingredient.name],
            maxOrders: ingredient.maxOrders,
        });
    }
    return strategies;
}
function getFactories(agentSide, hexProperties, mapHexes, scenario, rules) {
    return {
        achieveVictory: () => {
            return achieveVictoryStrategyFactory(scenario, agentSide, hexProperties, rules, mapHexes);
        },
        preventDefeat: () => {
            return preventDefeatStrategyFactory(scenario, mapHexes, agentSide, hexProperties, rules);
        },
        incurDamage: () => {
            return incurDamageStrategyFactory(agentSide, hexProperties, rules, mapHexes);
        },
        supportFriendlyUnit: () => {
            return supportFriendlyUnitStrategyFactory(agentSide, hexProperties, rules, mapHexes);
        },
        moveTowardsEnemy: () => {
            return moveTowardsEnemyStrategyFactory(agentSide, hexProperties, rules, mapHexes);
        },
        doNothing: () => {
            return doNothingStrategyFactory(agentSide);
        },
    };
}
export default createStrategies;
